export const menuNavigation = [
  {
    key: 'configurator',
    path: '/systems',
    img: 'order',
    isPublic: true,
    showIcon: false,
  },
  {
    key: 'saved-orders',
    path: '/saved-orders',
    img: 'list',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'orders',
    path: '/my-orders',
    img: 'cart',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'profile',
    path: '/profile',
    // img: 'profile',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'contact',
    path: '/contact',
    img: 'contact',
    isPublic: true,
    showIcon: false,
    isGuest: true,
  },
];

export const menuNavigationDealer = [
  {
    key: 'configurator',
    path: '/systems',
    img: 'order',
    isPublic: true,
    showIcon: false,
  },
  {
    key: 'clients-list',
    path: '/clients-list',
    img: 'clients',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'saved-orders',
    path: '/saved-orders',
    img: 'list',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'orders',
    path: '/my-orders',
    img: 'cart',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'profile',
    path: '/profile',
    // img: 'profile',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'contact',
    path: '/contact',
    img: 'contact',
    isPublic: true,
    showIcon: false,
    isGuest: true,
  },
];

export const menuNavigationManager = [
  {
    key: 'clients-list',
    path: '/clients-list',
    img: 'clients',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'saved-orders',
    path: '/saved-orders',
    img: 'list',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'orders',
    path: '/my-orders',
    img: 'cart',
    isPublic: false,
    showIcon: false,
  },
  {
    key: 'profile',
    path: '/profile',
    // img: 'profile',
    isPublic: false,
    showIcon: false,
  },
];

export const menuNavigationAdmin = [
  {
    key: 'configurator',
    path: '/systems',
    img: 'order',
  },
  {
    key: 'saved-orders',
    path: '/saved-orders',
    img: 'list',
  },
  {
    key: 'orders',
    path: '/my-orders',
    img: 'cart',
  },
  {
    key: 'profile',
    path: '/profile',
    img: 'profile',
  },
  {
    key: 'json-uploading',
    path: '/json-form',
    img: 'order',
  },
];
